<template>
  <div class="work-records-wrapper p-3">
    <button
      class="bg-transparent w-100 text-center border border-dashed p-0 mb-3 text-gray-600"
      v-on:click="showWorkRecordsFormModal = true"
    >
      <i class="fa fa-plus mr-2" aria-hidden="true"></i> Inserir registro
    </button>

    <button
      class="bg-transparent w-100 text-center border border-dashed p-0 mb-3 text-gray-600"
      v-on:click="showImportCnisModal = true"
    >
      <i class="fa fa-plus mr-2" aria-hidden="true"></i> Importar CNIS
    </button>

    <!-- <div class="border rounded border-info border-left-4 mb-3" style="background-color: #FAFB7F; border: 1px solid black !important;" v-if="indexDate">
      <div class="p-2 border-bottom d-flex align-items-center">
        <div>
          <h6 class="mb-2 text-gray-600 font-weight-bold">
            Índice Utilizado: {{ indexDate }}
          </h6>
        </div>
      </div>
    </div> -->

    <div class="border rounded border-info border-left-4 mb-3" style="background-color: #FAFB7F; border: 1px solid black !important;" v-if="isConcomitantTimeRGPS">
      <div class="p-2 border-bottom d-flex align-items-center">
        <div>
          <h6 class="mb-2 text-gray-600 font-weight-bold">
            Tempo concomitante RGPS em {{ concomitantWorkRecordsRGPS }}.
          </h6>
        </div>
      </div>
    </div>

    <div class="border rounded border-info border-left-4 mb-3" style="background-color: #FAFB7F; border: 1px solid black !important;" v-if="isConcomitantTimeRPPS">
      <div class="p-2 border-bottom d-flex align-items-center">
        <div>
          <h6 class="mb-2 text-gray-600 font-weight-bold">
            Tempo concomitante RPPS em {{ concomitantWorkRecordsRPPS }}.
          </h6>
        </div>
      </div>
    </div>

    <!-- <div class="alert alert-warning mb-3" v-if="isConcomitantTimeRGPS">
      <i class="fa fa-info-circle mr-2"></i>
      Tempo concomitante RGPS em {{ concomitantWorkRecordsRGPS }}.
    </div>

    <div class="alert alert-warning mb-3" v-if="isConcomitantTimeRPPS">
      <i class="fa fa-info-circle mr-2"></i>
      Tempo concomitante RPPS em {{ concomitantWorkRecordsRPPS }}.
    </div> -->

    <WorkRecordItem
      v-for="record in workRecords"
      v-bind:key="record.id"
      v-bind:item="record"
      v-on:addRemuneration="handlerAddRemuneration"
      v-on:edit="handlerEditWorkRecord"
      v-on:remove="handlerRemoveWorkRecord"
      v-on:addition="handlerAddition"
      v-on:deduction="handlerDeduction"
      v-on:divide="handlerDivideWorkRecord"
      v-on:regimeTypeChange="handlerRegimeTypeChange"
    />

    <!-- Modal -->
    <ModalImportCnisForm
      v-if="showImportCnisModal"
      v-bind:parentId="parentId"
      v-bind:updateIndex="updateIndex"
      v-on:hidden="handlerCloseModal"
      v-on:save="fetchWorkRecords"
    />

    <ModalWorkRecordsForm
      v-if="showWorkRecordsFormModal"
      v-bind:parentId="parentId"
      v-bind:record="recordSelected"
      v-on:hidden="handlerCloseModal"
      v-on:save="fetchWorkRecords"
    />

    <ModalDeductionForm
      v-if="showDeductionFormModal"
      v-bind:parentId="parentId"
      v-bind:record="recordSelected"
      v-on:hidden="handlerCloseModal"
      v-on:save="fetchWorkRecords"
      v-bind:regimeDate="regimeDate"
      v-bind:hasRegime="hasRegime"
    />

    <ModalAdditionForm
      v-if="showAdditionFormModal"
      v-bind:parentId="parentId"
      v-bind:record="recordSelected"
      v-on:hidden="handlerCloseModal"
      v-on:save="fetchWorkRecords"
    />

    <ModalRemunerationForm
      v-if="showRemunerationFormModal"
      v-bind:workRecord="recordSelected"
      v-bind:updateIndex="updateIndex"
      v-bind:hasJoinedSupplementaryPensionPlan="hasJoinedSupplementaryPensionPlan"
      v-on:hidden="handlerCloseModal"
      v-on:save="fetchWorkRecords"
    />

    <ModalDivideWorkRecord
      v-if="showDivideWorkRecordModal"
      v-bind:workRecord="recordSelected"
      v-bind:parentId="parentId"
      v-on:hidden="handlerCloseModal"
      v-on:save="fetchWorkRecords"
    />
  </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import WorkRecordItem from './components/WorkRecordItem';
import ModalWorkRecordsForm from './components/ModalWorkRecordsForm';
import ModalRemunerationForm from './components/ModalRemunerationForm';
import ModalDeductionForm from './components/ModalDeductionForm';
import ModalAdditionForm from './components/ModalAdditionForm';
import ModalImportCnisForm from './components/ModalImportCnisForm';
import ModalDivideWorkRecord from './components/ModalDivideWorkRecord';
import { getUpdateIndex } from '@/services/updateIndex';

export default {
  name: 'WorkRecords',
  components: {
    WorkRecordItem,
    ModalWorkRecordsForm,
    ModalRemunerationForm,
    ModalDeductionForm,
    ModalAdditionForm,
    ModalImportCnisForm,
    ModalDivideWorkRecord,
  },

  data: () => ({
    showWorkRecordsFormModal: false,
    showRemunerationFormModal: false,
    showDeductionFormModal: false,
    showAdditionFormModal: false,
    showImportCnisModal: false,
    showDivideWorkRecordModal: false,
    recordSelected: null,
    concomitantWorkRecordsRGPS: "",
    concomitantWorkRecordsRPPS: "",
    indexDate: null,
    updateIndex: "",
  }),

  props: {
    calculation: {
      type: Object,
      default: null
    },
    regimeDate: {
      type: [String],
      required: false
    },
    hasRegime: {
      type: [Boolean],
      required: false
    }
  },

  async created() {
    await this.loadWorkRecords(this.$route.params.calculationId);
    this.fetchUpdateIndex();
  },

  computed: {
    ...mapGetters('workRecords', ['workRecords']),

    hasJoinedSupplementaryPensionPlan() {
      const c = this.calculation;
      return c?.hasJoinedSupplementaryPensionPlan ?? c?.hasJoinedSupplemntaryPensionPlan ?? false;
    },

    parentId() {
      return parseInt(this.$route.params.calculationId);
    },

    isConcomitantTimeRGPS() {
      const rgpsWorkRecords = this.workRecords.filter(record => record.regimeType === 'RGPS');
      
      if (rgpsWorkRecords.length < 2) return false;

      let isConcomitant = false;
      const workRecords = [...rgpsWorkRecords];

      while (workRecords.length > 1) {
        const currentWorkRecord = workRecords.shift();

        for (const workRecord of workRecords) {
          if (moment(workRecord.ingressDate).isBetween(currentWorkRecord.ingressDate, currentWorkRecord.egressDate, null, '[]')) {
            isConcomitant = true;
            this.concomitantWorkRecordsRGPS = `${currentWorkRecord.companyName} e ${workRecord.companyName}`;
            break;
          }

          if (moment(workRecord.egressDate).isBetween(currentWorkRecord.ingressDate, currentWorkRecord.egressDate, null, '[]')) {
            isConcomitant = true;
            this.concomitantWorkRecordsRGPS = `${currentWorkRecord.companyName} e ${workRecord.companyName}`;
            break;
          }

          if (moment(currentWorkRecord.ingressDate).isBetween(workRecord.ingressDate, workRecord.egressDate, null, '[]') &&
              moment(currentWorkRecord.egressDate).isBetween(workRecord.ingressDate, workRecord.egressDate, null, '[]')) {
            isConcomitant = true;
            this.concomitantWorkRecordsRGPS = `${currentWorkRecord.companyName} e ${workRecord.companyName}`;
            break;
          }

          if (moment(workRecord.ingressDate).isBetween(currentWorkRecord.ingressDate, currentWorkRecord.egressDate, null, '[]') &&
              moment(workRecord.egressDate).isBetween(currentWorkRecord.ingressDate, currentWorkRecord.egressDate, null, '[]')) {
            isConcomitant = true;
            this.concomitantWorkRecordsRGPS = `${currentWorkRecord.companyName} e ${workRecord.companyName}`;
            break;
          }
        }

        if (isConcomitant) break;
      };

      return isConcomitant;
    },

    isConcomitantTimeRPPS() {
      const rppsWorkRecords = this.workRecords.filter(record => record.regimeType === 'RPPS');
      
      if (rppsWorkRecords.length < 2) return false;

      let isConcomitant = false;
      const workRecords = [...rppsWorkRecords];

      while (workRecords.length > 1) {
        const currentWorkRecord = workRecords.shift();

        for (const workRecord of workRecords) {
          if (moment(workRecord.ingressDate).isBetween(currentWorkRecord.ingressDate, currentWorkRecord.egressDate, null, '[]')) {
            isConcomitant = true;
            this.concomitantWorkRecordsRPPS = `${currentWorkRecord.companyName} e ${workRecord.companyName}`;
            break;
          }

          if (moment(workRecord.egressDate).isBetween(currentWorkRecord.ingressDate, currentWorkRecord.egressDate, null, '[]')) {
            isConcomitant = true;
            this.concomitantWorkRecordsRPPS = `${currentWorkRecord.companyName} e ${workRecord.companyName}`;
            break;
          }

          if (moment(currentWorkRecord.ingressDate).isBetween(workRecord.ingressDate, workRecord.egressDate, null, '[]') &&
              moment(currentWorkRecord.egressDate).isBetween(workRecord.ingressDate, workRecord.egressDate, null, '[]')) {
            isConcomitant = true;
            this.concomitantWorkRecordsRPPS = `${currentWorkRecord.companyName} e ${workRecord.companyName}`;
            break;
          }

          if (moment(workRecord.ingressDate).isBetween(currentWorkRecord.ingressDate, currentWorkRecord.egressDate, null, '[]') &&
              moment(workRecord.egressDate).isBetween(currentWorkRecord.ingressDate, currentWorkRecord.egressDate, null, '[]')) {
            isConcomitant = true;
            this.concomitantWorkRecordsRPPS = `${currentWorkRecord.companyName} e ${workRecord.companyName}`;
            break;
          }
        }

        if (isConcomitant) break;
      };

      return isConcomitant;
    }
  },

  methods: {
    ...mapActions('workRecords', ['loadWorkRecords']),

    fetchWorkRecords() {
      this.loadWorkRecords(this.$route.params.calculationId);
    },

    fetchUpdateIndex() {
      if (!this.calculation) return;
      const raw = this.calculation.calculationDate;
      let m;
      if (!raw) {
        m = moment();
      } else if (typeof raw === 'string' && raw.indexOf('/') !== -1) {
        m = moment(raw, 'DD/MM/YYYY', true);
      } else {
        m = moment(raw, 'YYYY-MM-DD', true);
      }
      if (!m.isValid()) m = moment(raw);
      const date = m.format('MM/YYYY');
      getUpdateIndex({ date })
        .then((response) => {
          this.updateIndex = response.updateIndex;

          if (!response.indexFoundInDate) {
            this.indexDate = response.indexDate;
          } else {
            this.indexDate = null;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    handlerAddRemuneration(record) {
      this.recordSelected = record;
      this.showRemunerationFormModal = true;
    },

    handlerEditWorkRecord(record) {
      this.recordSelected = record;
      this.showWorkRecordsFormModal = true;
    },

    handlerAddition(record) {
      this.recordSelected = record;
      this.showAdditionFormModal = true;
    },

    handlerDeduction(record) {
      this.recordSelected = record;
      this.showDeductionFormModal = true;
    },

    handlerDivideWorkRecord(record) {
      this.recordSelected = record;
      this.showDivideWorkRecordModal = true;
    },

    handlerImportCnis() {
      this.showImportCnisModal = true;
    },

    async handlerRemoveWorkRecord(record) {
      const result = await this.$swal.fire({
        title: 'Tem certeza que deseja remover esse registro?',
        text: 'Esta ação não poderá ser desfeita!',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, pode remover!'
      });

      if (!result.isConfirmed) { return; }

      try {
        await axios.delete(`/work-records/${record.id}`);

        this.$swal.fire(
          'Pronto!',
          `Removido com sucesso!`,
          'success'
        )
        await this.fetchWorkRecords();
      } catch (error) {
        this.$swal.fire(
          'Ops!',
          `Não foi possível remover, tente novamente mais tarde!`,
          'error'
        )
      }
    },

    handlerCloseModal() {
      this.showWorkRecordsFormModal = false;
      this.showRemunerationFormModal = false;
      this.showDeductionFormModal = false;
      this.showAdditionFormModal = false;
      this.showDivideWorkRecordModal = false;
      this.recordSelected = null;
      this.showImportCnisModal = false;
    },

    async handlerRegimeTypeChange(updatedItem) {
      try {
        await axios.put(`/work-records/${updatedItem.id}`, { workRecord: updatedItem });
        
        this.$toast.open({
          message: 'Regime alterado com sucesso',
          type: 'success',
          position: 'top-right'
        });

        await this.fetchWorkRecords();
      } catch (error) {
        this.$toast.open({
          message: 'Erro ao alterar regime',
          type: 'error',
          position: 'top-right'
        });
      }
    },
  },
}
</script>

<style scoped>
</style>
